
/**
 * Payload shape for the emoji picker: ordered list of emoji characters and search tags per emoji.
 */
export interface EmojiPickerPayload {
  list: string[];
  tags: Record<string, string[]>;
}

/**
 * Provides emoji picker data (list + tags) for the Clipping Studio emoji editor.
 * Implementations load from backend API (e.g. GET /api/clipping-studio/emoji-picker).
 */
export abstract class IEmojiPickerProvider {
  abstract getEmojiPicker(): Promise<EmojiPickerPayload>;
}
